exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-action{margin-bottom:4px}.crs-title{border-bottom:1px dashed #000;padding-bottom:10px}.clickable-card{cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}.clickable-card:hover{transform:translateY(-3px);box-shadow:0 4px 12px rgba(0,0,0,.15)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26702c40","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/switchStudent.vue
// module id = 84
// module chunks = 0